export * from '@gongxigames/framework/slot/modules/genericPopup/fader/Fader';
export * from '@gongxigames/framework/slot/modules/genericPopup/fader/FaderColor';
export * from '@gongxigames/framework/slot/modules/genericPopup/fader/FaderImage';
export * from '@gongxigames/framework/slot/modules/genericPopup/fader/FaderSpine';
